import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("tt_cart") || "[]");
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem("tt_cart", JSON.stringify(items));
    }, [items]);

    const add = (product) => {
        setItems((prev) => {
            const existing = prev.find((i) => i.id === product.id);
            if (existing)
                return prev.map((i) => (i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i));
            return [...prev, { id: product.id, name: product.name, price: product.price, image_url: product.image_url, quantity: 1 }];
        });
    };

    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const setQty = (id, qty) =>
        setItems((prev) => prev.map((i) => (i.id === id ? { ...i, quantity: Math.max(1, qty) } : i)));
    const clear = () => setItems([]);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);

    return (
        <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
